import React from 'react';
import { AlertClientBadge } from '../../styled';

const AlertCustomerTag = ({ statusOfChat, situationChat, statusName }) => {
  return (
    <h4 className="mt--2">
      <AlertClientBadge type={statusOfChat} situation={situationChat}>
        {statusName}
      </AlertClientBadge>
    </h4>
  );
};
export default AlertCustomerTag;
